import React from "react";
import { Popover, Button, Modal } from "antd";

import EditFilter from "../EditFilter/index";

const filters = [
  {
    id: 0,
    title: "Bioligical Context"
  },
  {
    id: 1,
    title: "Pharmacogenetics"
  },
  {
    id: 2,
    title: "Common Variants"
  },
  {
    id: 3,
    title: "Physical Location"
  },
  {
    id: 4,
    title: "Confidence"
  },
  {
    id: 5,
    title: "Predicted Deleterious"
  },
  {
    id: 6,
    title: "Custom Annotation"
  },
  {
    id: 7,
    title: "Statistical Association"
  },
  {
    id: 8,
    title: "Genetic Analysis"
  },
  {
    id: 9,
    title: "User-Defined Variants"
  }
];

class Filter extends React.Component {
  constructor() {
    super();
    this.state = {
      visibleModal: false
    };
  }

  showModal = () => {
    this.setState({
      visibleModal: true
    });
  };

  handleOk = () => {
    this.setState({ visibleModal: true });
  };

  handleCancel = () => {
    this.setState({ visibleModal: false });
  };

  render() {
    const popoverContent = (
      <div>
        <div className="popover-filters__list">
          {filters.map(x => (
            <div
              onClick={this.showModal}
              className="popover-filters__item"
              key={x.id}
            >
              {x.title}
            </div>
          ))}
        </div>
      </div>
    );

    const { visibleModal } = this.state;

    return (
      <div>
        <Popover
          overlayClassName="popover-filters"
          placement="bottomLeft"
          trigger="click"
          content={popoverContent}
        >
          <Button onClick={this.togglePopover} className="filters__add">
            <img src="/img/plus-blue.svg" alt="" />
            <span>Add filter</span>
          </Button>
        </Popover>
        <Modal
          width={772}
          zIndex={1040}
          visible={visibleModal}
          centered={true}
          title={false}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={false}
        >
          <EditFilter />
        </Modal>
      </div>
    );
  }
}

export default Filter;
